import { z } from '@betty/toolkit/api';
import { StatusSchema } from '../CommunityJackpotService/CommunityJackpotService.schemas';

export const MilestoneWinnerSchema = z.object({
  amount: z.number(),
  screenName: z.string(),
  winType: z.enum(['MilestoneFlip', 'Jackpot', 'Prize']),
  status: StatusSchema,
});

export const MilestoneWinnersSchema = z.object({
  milestoneWinners: z.array(MilestoneWinnerSchema),
});
